import React, {useEffect} from 'react';
import {Box, Table, TableBody, TableHead} from "@mui/material";
import {StyledTableCell, StyledTableRow} from '../common/table/TableStyles';
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import Typography from "@mui/material/Typography";
import {useLazyGetAppointmentsQuery} from "../../store/rtk-api/appointment/appointment";
import IsError from "../common/IsError";
import {useAppDispatch, useTypedSelector} from "../../store";
import {setAppointmentCount} from "../../store/calendar/calendar.slice";

type Props = {
    rowsPerPage: number,
}
const mapping = {
    'visitDate': 'Дата визита',
    'visitTime': 'время визита',
    'doctorName': 'Врач',
    'patient_name': 'Имя пациента',
    'patient_phone': 'Телефон пациента',
}

const AppointmentList: React.FC<Props> = ({rowsPerPage}) => {
    const dispatch = useAppDispatch()
    const {...filterData} = useTypedSelector(state => state.appointment)
    const [getAppointments, {data: appointments, isError, isLoading}] = useLazyGetAppointmentsQuery()

    useEffect(() => {
        getAppointments(filterData)
    }, [filterData.query, filterData.visit_date, filterData.page])

    useEffect(() => {
        if (appointments) {
            dispatch(setAppointmentCount(appointments?.count))
        }
    })
    return (
        <>
            <IsError isError={isError}/>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {Object.values(mapping).map((title, idx) => {
                            return (
                                <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                            )
                        })}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {isLoading ?
                        <TableLoadingMockup cellCount={6} rowCount={rowsPerPage}/>
                        :
                        appointments?.results?.map((item, ind) => (
                            <StyledTableRow key={item.id}>
                                <StyledTableCell>{`${item?.appointment_doctor_time?.date}`}</StyledTableCell>
                                <StyledTableCell>{item?.appointment_time}</StyledTableCell>
                                <StyledTableCell>
                                    <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <img style={{
                                            borderRadius: "50px",
                                            height: "40px",
                                            width: "40px"
                                        }}
                                             src={item?.appointment_doctor_time?.doctor?.photo}

                                        />
                                        <Typography>{`${item?.appointment_doctor_time?.doctor?.last_name} ${item?.appointment_doctor_time?.doctor?.first_name} ${item?.appointment_doctor_time?.doctor?.middle_name}`}</Typography>
                                    </Box>

                                </StyledTableCell>
                                <StyledTableCell>{`${item?.patient?.first_name}`}</StyledTableCell>
                                <StyledTableCell>{`${item?.patient?.phone}`}</StyledTableCell>
                                {/*<StyledTableCell>*/}
                                {/*    Статус?<br/>*/}
                                {/*    <Button sx={{textTransform: "capitalize", color: "secondary.main"}}*/}
                                {/*            onClick={() => navigate('status-change')}>Изменить</Button>*/}
                                {/*</StyledTableCell>*/}
                                {/*<StyledTableCell>Время?</StyledTableCell>*/}
                                <StyledTableCell>
                                    {/*<Button variant={"outlined"} sx={{*/}
                                    {/*    borderRadius: "10px",*/}
                                    {/*    backgroundColor: "#fff",*/}
                                    {/*    border: "1px solid #666666",*/}
                                    {/*    color: "#666666",*/}
                                    {/*    textTransform: "capitalize"*/}
                                    {/*}}>Просмотрено</Button>*/}
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                </TableBody>
            </Table>
            {appointments?.results.length === 0 && <div style={{padding: "10px"}}>Данных нет...</div>}
        </>
    );
};

export default AppointmentList;